const createConfig = (id) => ({
    name: `GTM-${id}`,
    dataLayer: `dataLayer${id}`
});
const installScript = (window) => (config) => {
    window[config.dataLayer] = [
        {
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        }
    ];
    const sibling = window.document.getElementsByTagName('script')[0];
    const script = window.document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${config.name}&l=${config.dataLayer}`;
    sibling.parentNode?.insertBefore(script, sibling);
};
const createClient = (config) => ({
    config,
    start: () => installScript(window)(config),
    stop: () => {
        window[config.dataLayer] = [];
        window[config.dataLayer].push = () => 0;
    },
    push: (data) => window[config.dataLayer]?.push(data)
});
const findCookies = (window) => (cookies) => [
    ...window.document.cookie.matchAll(new RegExp(`\\s*([^=\\s]*(?:${cookies.join('|')})+[^=\\s]*)=[^;]*;?`, 'gi'))
].map((match) => match[1]);
const deleteCookie = (window) => (cookie) => (domain) => (window.document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`);
export const clearCookies = (window) => (domains) => (cookies) => findCookies(window)(cookies)
    .map(deleteCookie(window))
    .forEach((deleter) => domains.forEach(deleter));
export default (id) => createClient(createConfig(id));
